// LoadingScreen.js
import React from 'react';
import './LoadingScreen.css'; // Assuming you have a CSS file for styling

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="spinner"></div>
      <p>Loading...</p>
    </div>
  );
};

export default LoadingScreen;
